import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/workSummary/table${`?query=${string}&startDate=${string}&endDate=${string}${`&subJobId=${number}` | ''}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/workSummary/table`;

/**
 * @param startDate YYYY-MM-DD
 * @param endDate YYYY-MM-DD
 */
export const URL = (jobId: number, tableQuery: TableQuery, startDate: string, endDate: string, subJobId: Nullable<number>): RouteDefinition =>
	`${baseRoute}/${jobId}/workSummary/table?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&startDate=${startDate}&endDate=${endDate}&subJobId=${subJobId}`;
